<template>
  <div class="chart-bar" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">
    <!-- <div class="title">
      <span>{{ title }}</span>
      <ElementSelect
        :val="year"
        @val="
          (e) => {
            year = e;
          }
        "
      />
    </div> -->
    <div class="chart-con unsetover">
      <div v-for="(item, index) in itemList" :class="'item item-' + index" @click="showModal(0, item)">
        <template v-if="typeof item.label === 'string'">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value">
            <b>{{ dataArr[item.key] || '-' }}</b
            ><span>{{ item.unit }}</span>
          </div>
        </template>
        <template v-else>
          <div class="line" v-for="(line, i) in item.label">
            <div class="item-label">{{ line }}</div>
            <div class="item-value">
              <b>{{ dataArr[item.key[i]] || '-' }}</b
              ><span>{{ item.unit }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <EleDialog :title="dialogTitle" :visible.sync="showDialog" :class="itemIndex === 2 && 'info-modal'">
      <template v-if="itemIndex === 2">
        <div class="item-title" :data-title="curData.c_entname"></div>
        <div class="item-content flex-between">
          <ul class="content-ul" v-for="ul in dialogUlList">
            <li v-for="li in ul">
              <div class="li-label">{{ li.label }}</div>
              <div class="li-value">{{ itemData[li.key] }}</div>
            </li>
          </ul>
        </div>
      </template>
      <div v-if="itemIndex === 2" class="item-title" data-title="项目月报"></div>
      <div v-else class="filter-box">
        <ElementSelect
          :val="search.city"
          :options="optionCity"
          @change="
            (e) => {
              search.city = e;
              refreshPage();
            }
          "
          size="middle"
        />
        <EleInput v-model="search.entName" placeholder="请输入企业名称" clearable />
      </div>
      <ComTable
        :tableCol="tableCol"
        :tableData="tableData"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :isPagination="itemIndex !== 2"
      />
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData"></CompModal>
    </EleDialog>
  </div>
</template>

<script>
import drawBar from '../chartJs/bar';
import { getBarData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import ElementSelect from '../../../components/element-select';
import echarts from 'echarts';
import drawLine from '../chartJs/PELine';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';
export default {
  name: 'ChartBar',
  components: { TabList, ElementSelect, ComTable, CompModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    apiName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    yearP: {
      type: Number,
      default: 2023,
    },
    srYeare: {
      type: Number,
      default: 2023,
    },

  },
  data() {
    return {
      loading: false,
      chartOption: null,
      chartData: null,
      itemList: [
        {
          key: 'ent_num',
          label: '参与民营企业',
          unit: '户',
        },
        {
          key: 'village_num',
          label: '帮扶村个数',
          unit: '个',
        },
        {
          key: 'project_num',
          label: '帮扶项目数',
          unit: '个',
        },
        {
          key: ['project_fund', 'donate_fund'],
          label: ['帮扶项目资金', '捐赠资金'],
          unit: '亿元',
        },
      ],
      dataArr: {},
      tabIndex: 0,
      itemIndex: 0,
      year: this.srYeare,
      showDialog: false,
      showCompany: false,
      dialogTitle: '',
      tableData: [],
      itemData: null,
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      search: {
        city: '全省',
        entName: '',
      },
      optionCity: [
        {
          value: '全省',
          label: '全省',
        },
        ...cityJson,
      ],
      curData: null,
    };
  },
  computed: {
    dialogUlList() {
      return [
        [
          {
            label: '项目名称:',
            key: 'c_projectname',
          },
          {
            label: '预计竣工时间:',
            key: 'c_planat',
          },
          {
            label: '项目状态:',
            key: 'c_status',
          },
        ],
        [
          {
            label: '帮扶企业:',
            key: 'c_entname',
          },
          {
            label: '实际竣工时间:',
            key: 'c_endat',
          },
          {
            label: '备注:',
            key: 'c_typeremark',
          },
        ],
        [
          {
            label: '启动时间:',
            key: 'c_begineat',
          },
          {
            label: '已投入帮扶资金（万元）:',
            key: 'c_helpfunds',
          },
        ],
      ];
    },
    tableCol() {
      let col = [];
      switch (this.itemIndex) {
        case 0:
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'c_citname',
            },
            {
              label: '县名',
              param: 'c_couname',
            },
            {
              label: '企业名称',
              param: 'c_entname',
              fn: (x) => {
                this.showDialog = false;
                this.curData = { ...x, companyName: x.c_entname };
                this.showCompany = true;
              },
            },
            {
              label: '帮扶项目数',
              param: 'c_num',
              fn: (x) => {
                console.log(123, x);
                this.search = {
                  city: '全省',
                  entName: x.c_entname,
                  entId: x.r_enterpresebase_id,
                };
                this.showModal(2, { unSet: true });
              },
            },
          ];
          break;
        case 1:
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市名',
              param: 'c_citname',
            },
            {
              label: '县名',
              param: 'c_couname',
            },
            {
              label: '村名',
              param: 'c_towname',
            },
            {
              label: '项目名称',
              param: 'c_projectname',
              fn: (x) => {
                console.log(123, x);
                this.search.projectId = x.c_id;
                this.curData = x;
                this.showItemInfo();
              },
            },
            {
              label: '帮扶企业名称',
              param: 'c_entname',
              fn: (x) => {
                this.showDialog = false;
                this.curData = { ...x, companyName: x.c_entname };
                this.showCompany = true;
              },
            },
          ];
          break;

        case 2:
          col = [
            {
              label: '年份',
              param: 'c_annual',
            },
            {
              label: '月份',
              param: 'c_period',
            },
            {
              label: '合计（万元）',
              param: 'hjzj',
            },
            {
              label: '已投入帮扶资金（万元)',
              param: 'ytrzj',
            },
            {
              label: '已捐赠帮扶物资（万元）',
              param: 'yjzzj',
            },
            {
              label: '项目状态',
              param: 'c_projectstatus',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  watch: {
    'search.entName'(n) {
      if (!n) {
        this.search.entName = null;
        this.search.id = null;
      }
      this.pager.currentPage = 1;
      this.$nextTick(() => this.refreshPage());
    },
    tabIndex() {
      this.pager = {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };
    },
    srYeare(n) {
      console.log(n, 112233);
      this.year = n;
      this.getData();
    },
  },
  methods: {
    getData() {
      this.$api.market.getLxshzrDetail({ year: this.srYeare }).then((res) => {
        let { data } = res.data.data;
        console.log(888, data.length);
        if (data.length) {
          this.dataArr = data[0];
          this.loading = false;
          this.$emit('getSrYList', this.year);
        } else {
          // if (this.year >= 2021) {
          //   this.year--;
          //   this.getData();
          // }
        }
      });
    },
    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
    showItemInfo() {
      this.itemIndex = 2;
      this.showDialog = true;
      this.dialogTitle = '项目详情';
      this.refreshPage();
    },
    showModal(index, item) {
      console.log(item);
      if (index === 0) {
        this.itemIndex = index;
        this.dialogTitle = '企业帮扶统计';
        if (!item.unSet) {
          this.search = {
            city: '全省',
            entName: null,
          };
        }
        this.refreshPage();
      } else if (index < 3) {
        this.itemIndex = 1;
        this.dialogTitle = '项目管理';
        if (!item.unSet) {
          this.search = {
            city: '全省',
            entName: '',
          };
          this.refreshPage();
        }
      } else return;
      this.showDialog = true;
    },
    refreshPage() {
      let dy = {};
      if (this.search.city && this.search.city !== '全省') dy.city = this.search.city + '市';
      if (this.search.entName) dy.entName = this.search.entName;
      console.log(778, this.search);
      switch (this.itemIndex) {
        case 0:
          this.$api.market
            .getLxshzrDetailList({
              year: this.year,
              pageNum: this.pager.currentPage,
              pageSize: 10,
              ...dy,
            })
            .then((res) => {
              if (res.data.data) {
                this.tableData = res.data.data.records;
                this.pager.total = res.data.data.total;
              } else {
                this.tableData = [];
                this.pager.total = 0;
              }
            });
          break;
        case 1:
          // dy.c_begineat = this.year;
          // if (this.search.id) {
          //   dy.r_enterpresebase_id = this.search.id;
          //   this.getProjectList(dy);
          // } else if (this.search.entName) {
          this.$api.market
            .getLxshzrDetailProject(
              {
                year: this.year,
                ...this.search,
                pageCurrent: this.pager.currentPage,
                pageSize: 10,
              },
              [],
              {
                showMsg: false,
              },
            )
            .then((res) => {
              this.tableData = res.data.data.records;
              this.pager.total = res.data.data.total;
              // if (res.data.data) {
              //   dy.r_enterpresebase_id = res.data.data[0].c_id;
              // }
              // this.getProjectList(dy);
            });
          // } else this.getProjectList(dy);

          break;
        case 2:
          this.tableData = [];
          let x = this.curData;
          this.$api.market
            .getLxshzrDetailProjectReport(
              {
                projectId: this.search.projectId,
              },
              [],
              {
                showMsg: false,
              },
            )
            .then((r) => {
              this.tableData = r.data.data.data.map((x) => ({
                ...x,
                c_projectstatus: +x.c_projectstatus ? '已竣工' : '进行中',
              }));
              console.log(r.data.data, this.curData, 1009);
              let x = this.curData;
              this.itemData = {
                ...x,
                c_planat: x.c_planat ? getTime(new Date(x.c_planat), 'yyyy-MM-dd') : '-',
                c_endat: x.c_endat ? getTime(new Date(x.c_endat), 'yyyy-MM-dd') : '-',
                c_begineat: x.c_begineat ? getTime(new Date(x.c_begineat), 'yyyy-MM-dd') : -'',
                r_enterpresebase_id: r.data.data.data[0]?.c_entname || '-',
                c_status: +x.c_status ? '已竣工' : '进行中',
              };
              // console.log(this.tableData);
            });
          // this.$api.common
          //   .getFormData(
          //     {
          //       dynamicConditions: {
          //         r_project_id: this.curData.c_id,
          //       },
          //       pageCurrent: this.pager.currentPage,
          //       pageSize: 10,
          //       syncFormId: 7,
          //     },
          //     [],
          //     {
          //       showMsg: false,
          //     },
          //   )
          //   .then((r) => {
          //     console.log(r.data.data.records[0]);
          //     this.tableData = r.data.data.records.map((x) => ({
          //       ...x,
          //       c_projectstatus: Number(x.c_projectstatus) ? '已竣工' : '进行中',
          //     }));
          //     this.pager.total = r.data.data.total;
          //     // .push({
          //     //   ...res.data.data.records[0],
          //     //   r_enterpresebase_id: r.data.data.records[0].c_entname,
          //     // });
          //     // console.log(this.tableData);
          //   });
          break;
        default:
          break;
      }
    },
    getProjectList(dy) {
      this.tableData = [];
      // this.$api.common
      //   .getFormData(
      //     {
      //       dynamicConditions: dy,
      //       pageCurrent: this.pager.currentPage,
      //       pageSize: 10,
      //       syncFormId: 8,
      //     },
      //     [],
      //     {
      //       showMsg: false,
      //     },
      //   )
      //   .then((res) => {
      //     res.data.data.records.map((x) => {
      //       this.$api.market
      //         .getVillageEnterprise(
      //           {
      //             dynamicConditions: {
      //               c_id: x.r_enterpresebase_id,
      //             },
      //             pageCurrent: 1,
      //             pageSize: 1,
      //             syncFormId: 9,
      //           },
      //           [],
      //           {
      //             showMsg: false,
      //           },
      //         )
      //         .then((r) => {
      //           console.log(r);
      //           if (r.data.data) {
      //             this.tableData.push({
      //               ...x,
      //               c_entname: r.data.data[0].c_entname,
      //             });
      //           } else {
      //             this.tableData.push(x);
      //           }
      //           console.log(this.tableData);
      //         });
      //     });
      //     this.pager.total = res.data.data.total;
      //   });
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.refreshPage();
    },
    handleCurrentChange(e) {
      console.log(e);
      this.pager.currentPage = e;
      this.refreshPage();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.chart-bar {
  .chart-box();
  .title {
    width: 100%;
    div {
      flex: 1;
      justify-content: flex-end;
      display: inline-flex;
      line-height: 1;
      align-items: center;
      .element-select {
        position: unset;
      }
    }
    #btn-link {
      margin-left: 32px;
    }
  }
  .chart-con {
    &.unsetover {
      overflow: unset;
      height: auto;
      padding-left: 12px;
    }
    .item {
      width: 176px;
      height: 80px;
      display: inline-flex;
      flex-direction: column;
      padding: 31px 0 0 69px;
      box-sizing: border-box;
      cursor: pointer;
      &.item-0 {
        background: url('~img/market/market-right-0.png') left bottom no-repeat;
        background-size: 170px 80px;
      }
      &.item-1 {
        width: calc(100% - 176px);
        background: url('~img/market/market-right-1.png') left bottom no-repeat;
        background-size: 170px 80px;
      }
      &.item-2 {
        background: url('~img/market/market-right-2.png') left bottom no-repeat;
        background-size: 170px 80px;
      }
      &.item-3 {
        width: calc(100% - 176px);
        padding-top: 26px;
        background: url('~img/market/market-right-31.png') left bottom no-repeat;
        background-size: 170px 80px;
        cursor: unset;
      }
      .line {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 59px;
        + .line {
          margin-top: 6px;
        }
        .item-value {
          margin: 0;
        }
      }
      .item-label {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 1;
        text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
        font-style: italic;
      }
      .item-value {
        white-space: nowrap;
        line-height: 1;
        margin-top: 7px;
        b {
          font-family: Geometr706 BlkCn BT;
          font-weight: 900;
          font-size: 22px;
          color: #ffffff;
          font-style: italic;
          background: linear-gradient(0deg, #8bb4d0 0%, rgba(255, 255, 255, 1) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          padding-right: 3px;
        }
        span {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #eff0f1;
          // line-height: 29px;
          opacity: 0.6;
          margin-left: 12px;
          white-space: nowrap;
        }
      }
    }
  }
  /deep/ .ele-dialog {
    &.info-modal {
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }

    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
  }
}
</style>
